<template style="">
 <div  style="width: 100%; background-color:#E6F0F2;" >
  <div  style="width: 50%;margin:0 auto;min-width:730px;" >
	<div style="padding-top:30px">
		<a href="https://www.ceprei.com/index.html">
		<img src="https://www.ceprei.com/assets/img/logo1-default.png" alt="Logo"></a>
		</div>
  </div>

	<div style="width: 100%;height:60px;background-color:#DCDCDC;padding-top:3px;padding-bottom:1px;" >
		<div style="width: 100%;height:60px;background-color:#E6F0F2;"> 
			<div  style="width:50%;margin:0 auto;min-width:730px;" >
				<div style="float:left;font-size:250%;font-weight:bold;margin-top:10px">证书报告验证中心</div>
				<div style="float:right;margin-top:15px;color:#97a8be"><a href="https://www.ceprei.com/">首页</a> / 证书报告验证中心 </div>
			</div> 
		</div> 
	</div>

	<div  style="width: 50%;margin:0 auto;margin-top:30px;min-width:730px;" >
			<el-input placeholder="请输入报告/证书编号" v-model="reportCodeSeach" style='width:60%;' size="large">
				<template slot="prepend">报告/证书编号:</template>
			</el-input>
			<el-input placeholder="请输入验证码" v-model="checkCodeSeach"   style='width:39%;'  size="large">
				<template slot="prepend">验证码:</template>
				<el-button slot="append" icon="el-icon-search" style='color: #08c;;font-weight:bold' @click="loadData()">查询/Search</el-button>
			</el-input>
	</div>

  <div v-if="!seachShow" id="tableID" style="width: 50%;margin:0 auto;border:1px dashed #000; margin-top:40px;min-width:730px" >
		<div  >
			<table  border ="0" style=" width: 100%;margin-left:0%;margin-top:2%;" >
				<tr v-if="data.ReportCode !=''&& data.ReportCode!=null">  <td class = 'tdclass'>报告/证书编号 ：</td> <td  class = 'tdclass2'>{{data.ReportCode}}</td></tr>
				<tr v-if="data.ReportType!=''&& data.ReportType!=null">   <td class = 'tdclass'>报告类型 ：</td> <td class = 'tdclass2'>  {{data.ReportType}}</td></tr>
				<tr v-if="data.CustomerName!=''&& data.CustomerName!=null"> <td class = 'tdclass'>客户名称 ： </td> <td class = 'tdclass2'> {{data.CustomerName}} </td>  </tr>
				<tr v-if="data.UnitAddress!=''&& data.UnitAddress!=null">   <td class = 'tdclass'>单位地址 ： </td> <td class = 'tdclass2' >  {{data.UnitAddress}}</td> </tr>
				<tr v-if="data.SampleName!=''&& data.SampleName!=null">  <td class = 'tdclass'>样品名称： </td> <td class = 'tdclass2'> {{data.SampleName}}</td> </tr>
				<tr v-if="data.FuselageNumber!=''&& data.FuselageNumber!=null">   <td class = 'tdclass'>机身/管理号：</td> <td class = 'tdclass2'>{{data.FuselageNumber}}</td></tr>
				<tr v-if="data.SampleCode!=''&& data.SampleCode!=null">  <td class = 'tdclass'>样品型号 ： </td> <td class = 'tdclass2'>  {{data.SampleCode}}</td>  </tr>
				<tr v-if="data.TestBasis!=''&& data.TestBasis!=null">  <td class = 'tdclass'>检测依据 ：</td> <td class = 'tdclass2'>  {{data.TestBasis}} </td>  </tr>
				<tr v-if="data.Conclusion!=''&& data.Conclusion!=null">   <td class = 'tdclass'>结论     ： </td> <td class = 'tdclass2'>  {{data.Conclusion}}</td>  </tr>
				<tr v-if="data.Reviewer!=''&& data.Reviewer!=null">  <td class = 'tdclass'>审核人： </td> <td class = 'tdclass2'> {{data.Reviewer}}</td>  </tr>
				<tr v-if="data.Issuer!=''&& data.Issuer!=null">   <td class = 'tdclass'>签发人   ： </td> <td class = 'tdclass2'>  {{data.Issuer}}</td> </tr>
				<tr v-if="data.IssueDate!=''&& data.IssueDate!=null">  <td class = 'tdclass'>签发日期 ：</td> <td class = 'tdclass2'> {{data.IssueDate}}</td></tr>
			</table>
			<br> 
		</div>
  </div> 
  <div style="widht:20px;height:1800px;background-color:#E6F0F2;" v-show="seachShow"></div>
	<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;<br>&nbsp;	<br>&nbsp;<br>&nbsp;<br>&nbsp;
  <div style="position:fixed;   bottom:0;  z-index:999;width:100%;    background-color: #3e4753;   color:rgb(218, 213, 213) ;  font-size: 14px " >
		<div align="center" style="width:100%;background-color: #E6F0F2;">
			<a href="http://guangzhou.cyberpolice.cn/netalarm/netalarm/Welcome.jsp?bano=4401060100873" data-v-4d3159fe="" target="_blank">
			<img src="https://ca.ceprei.com/_nuxt/img/cyberpolice.bfb5ba4.gif" border="0" data-v-4d3159fe=""></a>
		</div>
		<div style="width: 50%;margin:0 auto;padding-top:10px;min-width:730px">
				<div style="float: right;" ><a href="https://www.ceprei.com/index.html" ><img src="https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png" ></a>  </div>
				<p  >Copyright © 2015. 中国赛宝实验室 All rights reserved. &nbsp;<i class="icon-home" ></i>&nbsp;广州市增城区朱村街朱村大道西78号 &nbsp;粤ICP备09030372号</p>
				<p >网站维护：020-87237193 业务联系：020-87236881</p>
		</div>
  </div>
								
 



   
	 
    

  </div>
</template>
 <script>
import { RequestGet, url } from '../../api/api'
 

  export default {
    data() {
      
        
       return {
		errResult:'', 
		reportCodeSeach:'',
		checkCodeSeach:'',
		seachShow:true,
		 
		data:{},
      };
    },
    created:function(){
      
		 document.title = '中国赛宝官方网站-证书报告验证中心';
    },
    methods: {
		verify(data){
			if(data.reportCodeSeach==''){
				return '请输入查询编号';
			}
			if(data.checkCodeSeach==''){
				return '请输入验证码';
			}
			return null;
		},
		loadData(id) {
			this.errResult = '';
			var requestData={reportCodeSeach:this.reportCodeSeach,checkCodeSeach:this.checkCodeSeach};
			var msg = this.verify(requestData);
			if(msg!=null){
				this.$alert(msg, '填写错误',{lockScroll:false})
				return;
			}
			RequestGet("/weixin/getCertReportProveResultById",requestData).then(response => {
					if(response['data']==''||response['data']==undefined){
						this.$alert("内部证书编号：未查询到信息,如有疑问请进一步联系相关业务人员，谢谢！", '证书无效',{dangerouslyUseHTMLString: true,showCancelButton:true,lockScroll:false})
						this.resultShow=false;
						this.seachShow=true;
						return;
					}
					
					var obj1 = JSON.parse(response['data']); 
					var obj=obj1['data'];
					if(obj==undefined||obj['ReportCode']==undefined){
						this.$alert('内部证书编号：未查询到信息,如有疑问请进一步联系相关业务人员，谢谢！', '证书无效',{dangerouslyUseHTMLString: true,showCancelButton:true,lockScroll:false})
						this.resultShow=false;
						this.seachShow=true;
						return;
					}else{
						this.resultShow=true;
						this.seachShow=false;
						this.data = obj;
						if(this.data.IssueDate!=''&& this.data.IssueDate!=undefined && this.data.IssueDate!=null){
							this.data.IssueDate = this.data.IssueDate.split(' ')[0];
						}
					}
				}).catch(error => {
					this.resultShow=false;
					this.seachShow=true;
					this.$alert('请求失败,请联系相关业务人员', '请求错误',{lockScroll:false})
				})
      	 
			}
      
   	 	},
		
  }
</script>

    <style type="text/css">
	input{
		height: 50px;
	}
			#tableID table{
				margin-top: 40px;
				margin-left: 5px;
				font-size: 16px;
			} 
			#tableID table tr {
				height: 60px;
				
			}
			#tableID table tr td {
				fo: 40px;
				
			}
			a{ text-decoration:none; } 
		 	 
			.tdclass{
				width:25%;
				font-weight:bold ;
				padding-left: 5%;
			}
			.tdclass2{
				width:75%;
				padding-right: 5%;
			}
			 
			
		</style>	


// WEBPACK FOOTER //
// certificateAuthenticity.vue?7dc3e1a9